
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAffiliateReferralrequest, getUerReferralrequest, Admintotalreferrallist, AdminApproveReferralLinks } from "../../Api/AdminApiCall";

export const fetchAffiliateReferralrequest = createAsyncThunk(
    "admin/fetchAffiliateReferralrequest",
    async ({ page = 1, search = '', status }, { rejectWithValue }) => {
        try {
            const res = await getAffiliateReferralrequest(page, search, status);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchUserReferralrequest = createAsyncThunk(
    "admin/fetchUserReferralrequest",
    async ({ page = 1, search = '', status = '' }, { rejectWithValue }) => {
        try {
            const res = await getUerReferralrequest(page, search, status);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchAdmintotalreferrallist = createAsyncThunk(
    "admin/fetchAdmintotalreferrallist",
    async ({ page = 1, pageSize = 10, status = '', search = '', earning_type = '', start_date = '', end_date = '' }, { rejectWithValue }) => {
        try {
            const res = await Admintotalreferrallist(page, pageSize, status, search, earning_type, start_date, end_date);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);


export const fetchAdminApproveReferralLinks = createAsyncThunk(
    "admin/fetchAdminApproveReferralLinks",
    async (data, { rejectWithValue }) => {
        try {
            const res = await AdminApproveReferralLinks(data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

// AdminApproveReferralLinks

// Admintotalreferrallist

const AdminReferralRequestSlice = createSlice({
    name: "referralrequest",
    initialState: {
        Referralrequestdata: [],
        Referralrequestuser: [],
        Totalreferrallist: [],
        ReferralApprovedata :[],        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAffiliateReferralrequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAffiliateReferralrequest.fulfilled, (state, action) => {
                state.loading = false;
                state.Referralrequestdata = action.payload;
            })
            .addCase(fetchAffiliateReferralrequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchUserReferralrequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserReferralrequest.fulfilled, (state, action) => {
                state.loading = false;
                state.Referralrequestuser = action.payload;
            })
            .addCase(fetchUserReferralrequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchAdmintotalreferrallist.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdmintotalreferrallist.fulfilled, (state, action) => {
                state.loading = false;
                state.Totalreferrallist = action.payload;
            })
            .addCase(fetchAdmintotalreferrallist.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

             .addCase(fetchAdminApproveReferralLinks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdminApproveReferralLinks.fulfilled, (state, action) => {
                state.loading = false;
                state.ReferralApprovedata = action.payload;
            })
            .addCase(fetchAdminApproveReferralLinks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // fetchAdminApproveReferralLinks

        // fetchAdmintotalreferrallist
        // fetchUserReferralrequest


    },
});

const AdminReferralSliceReducer = AdminReferralRequestSlice.reducer;

export default AdminReferralSliceReducer;
